define('utils/service', [
    'http',
    'utils/tools',
    'utils/toast',
    'qs'
], function (http, tools, toast, qs) {
    'use strict';

    http.formPost = function (url, data) {
        return http({
            url: url,
            method: 'post',
            data: qs.stringify(data),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    }

    var handleError = function (promise, key, force) {
        var resolve_;
        key = key || 'dataObj';
        var isAll = typeof key === 'boolean';

        promise.then(function (res) {
            res = res.data // escape axios wrap 
            if (force || res && res.isok) {
                res = isAll ? res : res[key]
                resolve_(res || true)
            } else {
                toast.hideLoading()
                toast.show(res.Msg)
                resolve_(false)
            }
        })

        return new Promise(function (resolve) {
            resolve_ = resolve
        })
    }

    return {
        // 获取用户登陆信息
        getUserCookie: function () {
            var res = http.formPost("/dzhome/GetUserCookie")
            return handleError(res)
        },
        // 获取案例列表
        getCaseList: function (options) {
            var $options = {
                id: 0,
                tagId: 0,
                pageIndex: 1,
                pageSize: 12,
            }
            $options = tools.extend($options, options)
            var res = http.formPost("/dzhome/GetCaseListV2", $options)
            return handleError(res)
        },
        // 获取案例标签列表
        getCaseLabelList: function () {
            var res = http.formPost("/dzhome/GetHomeTagList")
            return handleError(res)
        },
        // 获取视频列表
        getVideoList: function (options) {
            var $options = {
                typeid: -1,
                themeid: -1,
                orderbytype: 0,
                pageIndex: 1,
                pageSize: 12,
            }
            $options = tools.extend($options, options)
            var res = http.formPost("/dzhome/GetVideoPlayList", $options)
            return handleError(res, true)
        },
        // 获取视频主题列表
        getVideoThemeList: function () {
            var res = http.formPost("/dzhome/GetVideoPlayThemeList")
            return handleError(res, 'dataObj', true)
        },
        // 提交加入表单(加入 or 定制)
        submitForm: function (options) {
            var $options = {
                Phone: 0,
                username: '',
                source: 0
            }
            $options = tools.extend($options, options)
            var res = http.formPost("/DLPT/SendUserAdvisory", $options)
            return handleError(res)
        },
        // 获取验证码
        getCode: function (phone) {
            var res = http.formPost("/dzhome/GetVaildCode", {
                phonenum: phone,
                type: 2
            })
            return handleError(res)
        },
        // 更新密码
        updatePwd: function (password, phone, code) {
            var res = http.formPost("/dzhome/UpdatePassword", {
                password: password,
                phone: phone,
                code: code
            })
            return handleError(res)
        },
        // 更新手机号
        updatePhone: function (phone, code) {
            var res = http.formPost("/dzhome/UpdatePhone", {
                phone: phone,
                code: code,
                type: 2
            })
            return handleError(res)
        }
    }
});
